import { JobsBoard } from "./Pages/Home";
import JobsHome from './Pages/Home';
import PostJob from './Pages/PostJob';
import JobDetails from './Pages/JobDetails';
import MyApplications from './Pages/MyApplications';
import Discover from './Pages/Discover';
import Notifications from './Pages/NotificationCenter';
import Funds from './Pages/Funds';
import BankPayouts from './Pages/BankPayouts';
import { CommunityChat, CommunitySearch, EditChatBackground, EditProfile, Entrance, ForgotPassword, NotFound, OTPVerification, Profile, ResetPassword, Settings, SignIn, SignUp, Splash, DeleteAccount, TermService, PrivacyPolicy, NewCommunity, Store, VIP, MyProducts, AddProduct, AddCourse, Chats, PrivateUserChat, CreateGroup, GroupChat, SubscriptionPlan, ManageChapter, AddChapter, ChapterContent, AddLesson, MyCommunity, StoreCourses, ProductDetails, MyLibrary, Chapters, ViewLesson, LessonsInChapter, StoreProducts, ChangePassword, AllStories, ZylenLanding, NoInternet, Activity, AboutUs } from './Pages/index';
import './styles/styles.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { CommunitiesProvider, UserProvider } from './contexts/UserContext';
import { CallPopupProvider } from './contexts/CallPopupContext';
import { NonMembersPopupProvider } from './contexts/NonMembersPopupContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AdminRoute, GuestRoute, ProtectedRoute } from './routes/AuthRoutes';
import NotificationToast from './notifications/NotificationToast';
import CustomToast from './utils/CustomToast';
import { DailyProvider } from '@daily-co/daily-react';
import DailyIframe from "@daily-co/daily-js";
import { CallProvider } from './contexts/CallContext';
import GlobalCallPopup from './components/GlobalCallPopup';
import AnalyticsTracker from './utils/AnalyticsTracker';
import ActiveChatBridge from './contexts/ActiveChatBridge';
import RestrictedRoute from './routes/RestrictedRoute';
import ViewUserProfile from './Pages/ViewUserProfile';
import TestDeleteAccount from './Pages/TestAccountDelete';
import mobileAppBridge from './utils/mobileAppBridge'; // Mobile app integration
import { useEffect } from 'react';
import VerifyPaystackPayment from './components/VerifyPayment';
import useNetworkStatus from './hooks/useOnlineStatus';
import CreateVoucher from './Pages/CreateVoucher';
import ApplyChallenge from './Pages/ApplyChallenge';
import CreateChallenge from './Pages/CreateChallenge';
import AdminApprovals from "./Pages/AdminApprovals";
import LandingEvents from './Pages/LandingEvents';
import { LandingSectionScroll } from "./components/landing/SectionLink";

let callObject;

if (typeof window !== "undefined" && navigator?.mediaDevices) {
  callObject = DailyIframe.createCallObject();
}


const App = () => {
  // Log if running in mobile app
  useEffect(() => {
    console.log('');
    console.log('╔═══════════════════════════════════════════╗');
    console.log('║   🎨 ZYLEN WEB APP LOADED                ║');
    console.log('╚═══════════════════════════════════════════╝');
    console.log('');
    console.log('Environment Check:');
    console.log('  window.isInApp:', window.isInApp);
    console.log('  Platform:', navigator.platform);
    console.log('  User Agent:', navigator.userAgent.substring(0, 50) + '...');
    console.log('');

    if (mobileAppBridge.isInMobileApp()) {
      console.log('✅ Running in: MOBILE APP (React Native WebView)');
      console.log('   - Native IAP will be used for subscriptions');
      console.log('   - window.openSubscription() should be available');
    } else {
      console.log('✅ Running in: WEB BROWSER');
      console.log('   - Stripe will be used for subscriptions');
      console.log('   - Normal web navigation');
    }
    console.log('');
    console.log('Ready to test "Become a Host" button!');
    console.log('═════════════════════════════════════════════');
    console.log('');
  }, []);

  useEffect(() => {
    const isInApp = mobileAppBridge.isInMobileApp(); // Detect if running inside WebView
    const isMobileBrowser = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isInApp || isMobileBrowser) {
      console.log("🛡️ Mobile app or mobile browser detected — applying selection restrictions");

      // 1️⃣ Inject CSS: everything non-selectable except inputs & textareas
      const style = document.createElement("style");
      style.innerHTML = `
      /* Make everything non-selectable */
      * {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
        -webkit-touch-callout: none !important;
      }

      img {
        -webkit-user-drag: none !important;
        pointer-events: none !important;
      }

      body {
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        user-select: none !important;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
      }

      /* Allow selection & clipboard in input and textarea */
      input, textarea {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
        -ms-user-select: text !important;
        user-select: text !important;
        -webkit-touch-callout: text !important;
      }
    `;
      document.head.appendChild(style);

      // 2️⃣ Prevent right-click outside input/textarea
      const handleContextMenu = (e) => {
        if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) e.preventDefault();
      };

      // 3️⃣ Prevent copy/cut/paste outside input/textarea
      const handleCopy = (e) => {
        if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) e.preventDefault();
      };
      const handleCut = (e) => {
        if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) e.preventDefault();
      };
      const handlePaste = (e) => {
        if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) e.preventDefault();
      };

      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("copy", handleCopy);
      document.addEventListener("cut", handleCut);
      document.addEventListener("paste", handlePaste);

      // Cleanup on unmount
      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("copy", handleCopy);
        document.removeEventListener("cut", handleCut);
        document.removeEventListener("paste", handlePaste);
        document.head.removeChild(style);
      };
    }
  }, []);


  useEffect(() => {
    if (window.isInApp && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "DEBUG_USER_AGENT",
          userAgent: navigator.userAgent,
          ios: window.isIOS || false,
          android: window.isAndroid || false,
        })
      );
    }
  }, []);

  useEffect(() => {
    const handleNativeMessage = (event) => {
      let data;

      try {
        data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;
      } catch (err) {
        return;
      }

      if (!data || !data.type) return;

      console.log("📩 Message from React Native:", data);

      if (data.type === "IMAGE_DOWNLOADED") {
        if (data.success) {
          window.showToast("Image saved to gallery", 'success');
        } else {
          window.showToast("Image download failed", 'error');
        }
      }
    };

    if (window.isInApp) {
      document.addEventListener('message', handleNativeMessage);  // Android
      window.addEventListener('message', handleNativeMessage);  // iOS
      return () => {
        document.removeEventListener("message", handleNativeMessage);
        window.removeEventListener('message', handleNativeMessage);
      };
    }
  }, []);

  const isOnline = useNetworkStatus();

  return (
    <Router>
      <ThemeProvider>
        {!isOnline ? (
          <NoInternet />
        ) : (
          <DailyProvider callObject={callObject}>
            <UserProvider>
              <CommunitiesProvider>
                <CallProvider>
                  <CallPopupProvider>
                    <NonMembersPopupProvider>
                      <ActiveChatBridge />
                      <NotificationToast />
                      <GlobalCallPopup />
                      <CustomToast />
                      <AnalyticsTracker />
                      <LandingSectionScroll />
                      <Routes>
                        <Route path={ROUTES.SPLASH} element={<ZylenLanding />} />
                        <Route path={ROUTES.LANDING_EVENTS} element={<LandingEvents />} />
                        <Route path={ROUTES.ABOUT_US} element={<AboutUs />} />
                        <Route path={ROUTES.MAIN} element={<Splash />} />
                        <Route path={ROUTES.ONBOARDING} element={<Entrance />} />

                        <Route element={<GuestRoute />}>
                          <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
                          <Route path={ROUTES.SIGN_UP} element={<SignUp />} />
                          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
                          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
                          <Route path={ROUTES.OTP_VERIFICATION} element={<OTPVerification />} />
                        </Route>

                        <Route path={ROUTES.PREVIEW_PRODUCT} element={<ProductDetails />} />
                        <Route path={ROUTES.PREVIEW_PRODUCT_DETAILS} element={<ProductDetails />} />
                        <Route path={ROUTES.PREVIEW_MARKETPLACE} element={<Store />} />
                        <Route path={`${ROUTES.PREVIEW_STORE_PRODUCTS}/:category`} element={<StoreProducts />} />
                        <Route path={ROUTES.PREVIEW_STORE_COURSES} element={<StoreCourses />} />
                        <Route path={`${ROUTES.PREVIEW_COMMUNITY}/:communityId`} element={<CommunityChat />} />


                        <Route element={<ProtectedRoute />}>
                          <Route path={ROUTES.DASHBOARD} element={<JobsHome />} />
                          <Route path={ROUTES.PROFILE} element={<Profile />} />
                          <Route path="/discover" element={<Discover />} />
                          <Route path="/notifications" element={<Notifications />} />
                          <Route path="/funds" element={<Funds />} />
                          <Route path="/bank-payouts" element={<BankPayouts />} />
                          <Route path="/post-job" element={<PostJob />} />
                          <Route path="/jobs" element={<JobsBoard />} />
                          <Route path="/jobs/:jobId" element={<JobDetails />} />
                          <Route path="/my-applications" element={<MyApplications />} />
                          <Route path={ROUTES.STORE} element={<Store />} />
                          <Route path={ROUTES.VIP} element={<VIP />} />

                          <Route path={ROUTES.TEST_DELETE_ACCOUNT} element={<TestDeleteAccount />} />
                          <Route path={ROUTES.CREATE_VOUCHER} element={<CreateVoucher />} />
                          <Route path={ROUTES.VERIFY_PAYMENT} element={<VerifyPaystackPayment />} />


                          <Route path={ROUTES.EDIT_PROFILE} element={<EditProfile />} />
                          <Route path={ROUTES.ACCOUNT_ACTIVITY} element={<Activity />} />
                          <Route path={ROUTES.SETTINGS} element={<Settings />} />
                          <Route path={ROUTES.EDIT_CHAT_BACKGROUND} element={<EditChatBackground />} />
                          <Route path={ROUTES.DELETE_ACCOUNT} element={<DeleteAccount />} />
                          <Route path={ROUTES.CHANGE_PASSWORD} element={<ChangePassword />} />
                          <Route path={ROUTES.TERM_OF_SERVICE} element={<TermService />} />
                          <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
                          <Route path={ROUTES.COMMUNITY_SEARCH} element={<CommunitySearch />} />
                          <Route path={`${ROUTES.COMMUNITY_CHAT}/:communityId`} element={<CommunityChat />} />
                          <Route path={ROUTES.CHATS} element={<Chats />} />
                          <Route path={`${ROUTES.PRIVATE_USER_CHAT}/:userId`} element={<PrivateUserChat />} />
                          <Route path={`${ROUTES.CREATE_GROUP}/:id?`} element={<CreateGroup />} />
                          <Route path={`${ROUTES.GROUP_CHAT}/:groupId`} element={<GroupChat />} />
                          <Route path={ROUTES.SUBSCRIPTION_PLAN} element={<SubscriptionPlan />} />
                          <Route path={ROUTES.STORE_COURSES} element={<StoreCourses />} />
                          <Route path={`${ROUTES.PRODUCT_DETAILS}/:productId`} element={<ProductDetails />} />
                          <Route path={ROUTES.MY_LIBRARY} element={<MyLibrary />} />
                          <Route path={`${ROUTES.CHAPTERS}/:productId`} element={<Chapters />} />
                          <Route path={`${ROUTES.LESSONS_IN_CHAPTER}/:productId`} element={<LessonsInChapter />} />
                          <Route path={`${ROUTES.VIEW_LESSON}/:productId`} element={<ViewLesson />} />
                          <Route path={`${ROUTES.STORE_PRODUCTS}/:category`} element={<StoreProducts />} />
                          <Route path={`${ROUTES.VIEW_PROFILE}/:userId`} element={<ViewUserProfile />} />
                          <Route path={ROUTES.APPLY_CHALLENGE} element={<ApplyChallenge />} />

                          {/* Only Host or Paid users can access these routes */}
                          <Route element={<RestrictedRoute allowedRoles={['Host']} />}>
                            <Route path={`${ROUTES.NEW_COMMUNITY}/:id?`} element={<NewCommunity />} />
                            <Route path={ROUTES.MY_PRODUCTS} element={<MyProducts />} />
                            <Route path={ROUTES.ADD_PRODUCT} element={<AddProduct />} />
                            <Route path={ROUTES.ADD_COURSE} element={<AddCourse />} />
                            <Route path={`${ROUTES.MANAGE_CHAPTER}/:courseId`} element={<ManageChapter />} />
                            <Route path={ROUTES.ADD_CHAPTER} element={<AddChapter />} />
                            <Route path={`${ROUTES.CHAPTER_CONTENT}/:courseId`} element={<ChapterContent />} />
                            <Route path={ROUTES.ADD_LESSON} element={<AddLesson />} />
                            <Route path={ROUTES.MY_COMMUNITY} element={<MyCommunity />} />
                          </Route>

                          <Route element={<AdminRoute />}>
                            <Route path={ROUTES.CREATE_CHALLENGE} element={<CreateChallenge />} />
                            <Route path={ROUTES.ADMIN_APPROVALS} element={<AdminApprovals />} />
                          </Route>


                        </Route>
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </NonMembersPopupProvider>
                  </CallPopupProvider>
                </CallProvider>
              </CommunitiesProvider>
            </UserProvider>
          </DailyProvider>
        )}
      </ThemeProvider>

    </Router>
  );
}
export default App;

export const ROUTES = {
  SPLASH: '/',
  LANDING_EVENTS: '/events',
  MAIN: '/main',
  ONBOARDING: '/on-boarding',
  SIGN_IN: '/sign-in',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  SIGN_UP: '/sign-up',
  OTP_VERIFICATION: '/otp-verification',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  EDIT_PROFILE: '/edit-profile',
  SETTINGS: '/settings',
  EDIT_CHAT_BACKGROUND: '/edit-chat-background',
  TEST_DELETE_ACCOUNT: '/test-delete-account',
  DELETE_ACCOUNT: '/delete-account',
  TERM_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
  NEW_COMMUNITY: '/create-community',
  COMMUNITY_SEARCH: '/community-search',
  COMMUNITY_CHAT: '/community',
  STORE: '/library',
  VIP: '/vip',
  MY_PRODUCTS: '/my-products',
  ADD_PRODUCT: '/add-product',
  ADD_COURSE: '/add-course',
  CHATS: '/chats',
  PRIVATE_USER_CHAT: '/chat',
  CREATE_GROUP: '/create-group',
  GROUP_CHAT: '/group-chat',
  SUBSCRIPTION_PLAN: '/subscription-plan',
  MANAGE_CHAPTER: '/manage-chapter',
  ADD_CHAPTER: '/add-chapter',
  CHAPTER_CONTENT: '/chapter-content',
  ADD_LESSON: '/add-lesson',
  MY_COMMUNITY: '/my-community',
  STORE_COURSES: '/courses',
  PRODUCT_DETAILS: '/product',
  MY_LIBRARY: '/my-library',
  CHAPTERS: '/chapters',
  LESSONS_IN_CHAPTER: '/lessons-in-chapter',
  VIEW_LESSON: '/view-lesson',
  CREATE_ROOM_API: '/create-room',
  STORE_PRODUCTS: '/products',
  VIEW_PROFILE: '/user-profile',
  STORIES: '/stories',
  CHANGE_PASSWORD: '/change-password',
  VERIFY_PAYMENT: '/verify-payment',
  CREATE_VOUCHER: '/create-voucher',
  ACCOUNT_ACTIVITY: '/account-activity',
  CREATE_CHALLENGE: '/create-challenge',
  APPLY_CHALLENGE: '/apply-challenge',
  PREVIEW_PRODUCT: '/preview/:slug/:productId',
  PREVIEW_PRODUCT_DETAILS: '/preview/:productId',
  PREVIEW_MARKETPLACE: '/preview/marketplace/',
  PREVIEW_STORE_PRODUCTS: '/preview/products',
  PREVIEW_STORE_COURSES: '/preview/courses/',
  PREVIEW_COMMUNITY: '/preview/community',
  ABOUT_US: '/about-us',
  ADMIN_APPROVALS: "/admin/approvals",
  // Add all your routes here
};
